var map = {
	"./1.png": 3426,
	"./2.png": 3427,
	"./3-plus.png": 3428,
	"./3.png": 3429
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers .\.png*
// module id = 677
// module chunks = 0